export default __webpack_public_path__ + "static/media/RealCase-mobile-sc.3a5f6281.jpg";